export const FETCH_TRANSACTION_HISTORY_REQUEST = 'FETCH_TRANSACTION_HISTORY_REQUEST';
export const FETCH_TRANSACTION_HISTORY_SUCCESS = 'FETCH_TRANSACTION_HISTORY_SUCCESS';
export const FETCH_TRANSACTION_WIN_HISTORY_SUCCESS = 'FETCH_TRANSACTION_WIN_HISTORY_SUCCESS';
export const FETCH_TRANSACTION_LOSE_HISTORY_SUCCESS = 'FETCH_TRANSACTION_LOSE_HISTORY_SUCCESS';
export const FETCH_TRANSACTION_DEPOSIT_HISTORY_SUCCESS =
  'FETCH_TRANSACTION_DEPOSIT_HISTORY_SUCCESS';
export const FETCH_TRANSACTION_WITHDRAW_HISTORY_SUCCESS =
  'FETCH_TRANSACTION_WITHDRAW_HISTORY_SUCCESS';
export const FETCH_TRANSACTION_HISTORY_FAILURE = 'FETCH_TRANSACTION_HISTORY_FAILURE';
export const RESET_TRANSACTION_HISTORY_STATE = 'RESET_TRANSACTION_HISTORY_STATE';
